import { createContext } from 'react';

const DescriptionContext = createContext({})

export  {DescriptionContext}
